import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarThree: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      d="M16.8438 21.0987H14.4218L14.4218 17.9747C14.4218 17.4491 13.7294 17.0231 13.2517 17.0231L11.1892 17.0231C10.7114 17.0231 10.3242 16.597 10.3242 16.0714L10.3242 15.3101C10.3242 14.7845 10.7114 14.3584 11.1892 14.3584L13.2517 14.3584C13.7294 14.3584 14.4218 14.7845 14.4218 15.3101V15.9763C14.4218 16.5018 14.8091 16.9279 15.2868 16.9279H15.9788C16.4565 16.9279 16.8438 17.354 16.8438 17.8795L16.8438 21.0987Z"
      fill={color}
    />
    <path
      d="M7.56211 19.8154C8.03983 19.8154 8.42709 20.2414 8.42709 20.767V21.4332C8.42709 21.9587 8.81436 22.3848 9.29208 22.3848L15.9788 22.3848C16.4565 22.3848 16.8438 21.9587 16.8438 21.4332V20.6718C16.8438 20.1463 16.4565 19.7202 15.9788 19.7202L9.29208 19.7202C8.81436 19.7202 8.42709 19.2941 8.42709 18.7685L8.42709 13.9588H6.00513V18.8637C6.00513 19.3893 6.3924 19.8154 6.87012 19.8154H7.56211Z"
      fill={color}
    />
    <path
      d="M8.42196 16.1958H6V12.5431C6 12.0175 6.38727 11.5914 6.86499 11.5914H7.55698C8.0347 11.5914 8.42196 11.1654 8.42196 10.6398V9.97362C8.42196 9.44804 8.80923 9.02197 9.28695 9.02197H15.9736C16.4514 9.02197 16.8386 9.44804 16.8386 9.97362V10.7349C16.8386 11.2605 16.4514 11.6866 15.9736 11.6866L9.28695 11.6866C8.80923 11.6866 8.42196 12.1127 8.42196 12.6382L8.42196 16.1958Z"
      fill={color}
    />
    <path
      d="M12.2149 19.7202H13.2517C13.7294 19.7202 14.4218 19.2941 14.4218 18.7686V17.8133H16.8438V18.8637C16.8438 19.3893 16.4565 19.8154 15.9788 19.8154H15.2868C14.8091 19.8154 14.4218 20.2414 14.4218 20.767V21.4332C14.4218 21.9587 13.7294 22.3848 13.2517 22.3848H12.2149V19.7202Z"
      fill={color}
    />
    <path
      d="M15.1562 21.0987H17.5782L17.5782 17.9747C17.5782 17.4491 18.2706 17.0231 18.7483 17.0231L20.8108 17.0231C21.2886 17.0231 21.6758 16.597 21.6758 16.0714L21.6758 15.3101C21.6758 14.7845 21.2886 14.3584 20.8108 14.3584L18.7483 14.3584C18.2706 14.3584 17.5782 14.7845 17.5782 15.3101V15.9763C17.5782 16.5018 17.1909 16.9279 16.7132 16.9279H16.0212C15.5435 16.9279 15.1562 17.354 15.1562 17.8795L15.1562 21.0987Z"
      fill={color}
    />
    <path
      d="M24.4379 19.8154C23.9602 19.8154 23.5729 20.2414 23.5729 20.767V21.4332C23.5729 21.9587 23.1856 22.3848 22.7079 22.3848L16.0212 22.3848C15.5435 22.3848 15.1562 21.9587 15.1562 21.4332V20.6718C15.1562 20.1463 15.5435 19.7202 16.0212 19.7202L22.7079 19.7202C23.1856 19.7202 23.5729 19.2941 23.5729 18.7685V13.9588H25.9949V18.8637C25.9949 19.3893 25.6076 19.8154 25.1299 19.8154H24.4379Z"
      fill={color}
    />
    <path
      d="M23.578 16.1958H26V12.5431C26 12.0175 25.6127 11.5914 25.135 11.5914H24.443C23.9653 11.5914 23.578 11.1654 23.578 10.6398V9.97362C23.578 9.44804 23.1908 9.02197 22.713 9.02197H16.0264C15.5486 9.02197 15.1614 9.44804 15.1614 9.97362V10.7349C15.1614 11.2605 15.5486 11.6866 16.0264 11.6866L22.713 11.6866C23.1908 11.6866 23.578 12.1127 23.578 12.6382V16.1958Z"
      fill={color}
    />
    <path
      d="M19.7851 19.7202H18.7483C18.2706 19.7202 17.5782 19.2941 17.5782 18.7686V17.8133H15.1562V18.8637C15.1562 19.3893 15.5435 19.8154 16.0212 19.8154H16.7132C17.1909 19.8154 17.5782 20.2414 17.5782 20.767V21.4332C17.5782 21.9587 18.2706 22.3848 18.7483 22.3848H19.7851V19.7202Z"
      fill={color}
    />
  </svg>
);

export default AvatarThree;
